
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "@/components/businesses/BusinessSearch";

const Search = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/businesses?search=${encodeURIComponent(searchTerm)}`);
    }
  };

  return (
    <SearchBar
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      handleSearch={handleSearch}
      placeholder="Search for sustainable businesses..."
      className="relative max-w-lg mx-auto"
    />
  );
};

export default Search;
